import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { RouterLink } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { SiemensLogoComponent } from "src/app/core/icons/siemens-logo.component";
import { AppSettings } from "../../config/app-settings.config";
import { IconTriangleWarningComponent } from "../../icons/icon-triangle-warning.component";
import { NonProductionBannerComponent } from "../non-production-banner/non-production-banner.component";

@Component({
  selector: "app-not-found",
  templateUrl: "./not-found.component.html",
  styleUrls: ["./not-found.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, SiemensLogoComponent, NonProductionBannerComponent, IconTriangleWarningComponent],
})
export class NotFoundComponent {
  protected readonly translate = inject(TranslateService);

  public readonly appName = AppSettings.appName;

  public readonly label = <const>{
    homeButton: toSignal<unknown>(this.translate.stream("ERROR.HOME_BUTTON")),
  };
}
